import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CTASection() {
  return <section id="cta" className="py-32 bg-stone-950 text-stone-50" data-id="element-846">
      <div className="max-w-6xl mx-auto px-6" data-id="element-847">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-848">
          <div className="max-w-3xl" data-id="element-849">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-850">
              Get Started
            </p>

            <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-[1.1] text-stone-50 mb-8" data-id="element-851">
              Ready to stop leaking margin?
            </h2>

            <p className="text-xl text-stone-400 leading-relaxed mb-12" data-id="element-852">
              Start with a 90-day pilot. Defined baseline, clear KPIs, and a
              savings-share model that means we only win when you do.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-853">
              <Link to="/app" className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-8 py-4 text-sm font-medium transition-colors" data-id="element-854">
                Try the Demo
                <ArrowRight className="w-4 h-4" data-id="element-855" />
              </Link>
              <Link to="/deck" className="flex items-center justify-center gap-2 border border-stone-700 hover:border-stone-600 text-stone-300 hover:text-stone-50 px-8 py-4 text-sm font-medium transition-colors" data-id="element-856">
                View the Pitch Deck
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}